module.exports = __webpack_public_path__ + "img/schema_verticalisateur_3a.b07fdb60.svg";